<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:15px;">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addIndicator" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加指标</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :data="data" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" width="45" align="center" />
          <el-table-column prop="itemName" label="指标名称" show-overflow-tooltip />
          <el-table-column prop="score" label="分值" show-overflow-tooltip />
          <!--          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />-->
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此指标吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!--指标item弹窗-->
    <el-dialog
      :title="editCategoryItemForm.id ? '修改班级量化考评指标' : '添加班级量化考评指标'"
      :visible.sync="showEditCategoryItem"
      width="400px"
      @closed="editCategoryItemForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editCategoryItemForm" ref="editCategoryItemForm" :rules="editCategoryItemRules" label-width="100px">
        <el-form-item label="指标名称:" prop="itemName">
          <el-input v-model="editCategoryItemForm.itemName" placeholder="请输入指标名称" clearable />
        </el-form-item>
        <el-form-item label="分值:" prop="score">
          <el-input-number
            v-model="editCategoryItemForm.score"
            controls-position="right"
            class="ele-fluid ele-text-left"
            placeholder="请输入分值"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditCategoryItem = false">取消</el-button>
        <el-button type="primary" @click="saveCategoryItem(editCategoryItemForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { addClassAssessItem, deleteClassAssessItem, getClassAssessItemList, updateClassAssessItem } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        table: {
          page: false,
        },
        data: [],
        choose: [],
        showEditCategoryItem: false,
        editCategoryItemForm: {},
        editCategoryItemRules: {
          itemName: [{ required: true, message: '请输入指标名称', trigger: 'blur' }],
          score: [{ required: true, message: '请输入分数', trigger: 'blur' }],
        },
      };
    },
    created() {
      this.getIndicatorData();
    },
    methods: {
      // 获取指标
      getIndicatorData() {
        getClassAssessItemList().then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data;
          }
        });
      },
      // 添加指标弹窗并获取指标
      addIndicator() {
        this.showEditCategoryItem = true;
      },
      /* 显示编辑 */
      edit(row) {
        // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能更改除初始管理员');
        this.editCategoryItemForm = Object.assign({}, row, {});
        this.showEditCategoryItem = true;
      },
      // 保存修改班级量化指标
      saveCategoryItem(id) {
        this.$refs['editCategoryItemForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editCategoryItemForm) {
              if (this.editCategoryItemForm[key] !== null && this.editCategoryItemForm[key] !== undefined) {
                formData.append(key, this.editCategoryItemForm[key]);
              }
            }
            if (id == undefined) {
              // 添加指标
              addClassAssessItem(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditCategoryItem = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.getIndicatorData();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              // 编辑指标
              updateClassAssessItem(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditCategoryItem = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.getIndicatorData();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      remove(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('itemId', row.id);
        deleteClassAssessItem(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.showEditCategoryItem = false;
            this.$message({ type: 'success', message: res.data.resMsg });
            this.getIndicatorData();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
